import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: any = {
  studentClassExamList: [],
  loading: false,
  examDetail: {},
  answerCountData: {},
  examResult: {},
  error: null,
};

const studentExamSlice = createSlice({
    name: 'exam',
    initialState,
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload;
        },
        setStudentClassExamList(state, action) {
            state.studentClassExamList = action.payload;
        },
        setExamDetail(state, action) {
            state.examDetail = action.payload;
        },
        setExamDetailQuestions(state, action: PayloadAction<any[]>) {
            if (state.examDetail && typeof state.examDetail === 'object') {
                const questions = action.payload;
                const question_answer = questions.filter(
                    (q) => (q?.answer_status ?? 0) !== 0,
                ).length;
                state.examDetail = {
                    ...state.examDetail,
                    questions,
                    question_answer,
                };
            }
        },
        setAnswerCountData(state, action) {
            state.answerCountData = action.payload;
        },
        setExamResult(state, action) {
            state.examResult = action.payload
        },
        setExamError(state, action) {
            state.error = action.payload;
        },
        resetStudentExamData(state) {
            state.studentClassExamList = initialState.studentClassExamList;
            state.examDetail = initialState.examDetail;
            state.loading = initialState.loading;
            state.answerCountData = initialState.answerCountData;
            state.examResult = initialState.examResult;
            state.error = null;
        }
    },
});

export const {
    setLoading,
    setStudentClassExamList,
    setExamDetail,
    setExamDetailQuestions,
    setAnswerCountData,
    resetStudentExamData,
    setExamResult,
    setExamError,
} = studentExamSlice.actions;

export default studentExamSlice.reducer;